import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ChatIdService {
  createMessageEntityId(): string {
    return `mid-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 9)}`;
  }

  createSessionId(): string {
    const cryptoRef = globalThis.crypto;
    const uuid = typeof cryptoRef?.randomUUID === 'function'
      ? cryptoRef.randomUUID()
      : this.createFallbackUuid();

    return uuid.replace(/-/g, '');
  }

  private createFallbackUuid(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, character => {
      const random = Math.random() * 16 | 0;
      const value = character === 'x' ? random : (random & 0x3 | 0x8);
      return value.toString(16);
    });
  }
}
